export function playCurtainSwoosh(delay = 0.5) {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  const t0 = ctx.currentTime + delay;
  const dur = 2.2;

  const buffer = ctx.createBuffer(1, Math.ceil(ctx.sampleRate * dur), ctx.sampleRate);
  const data = buffer.getChannelData(0);
  let last = 0;
  for (let i = 0; i < data.length; i++) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02;
    data[i] = last * 3.5;
  }
  const src = ctx.createBufferSource();
  src.buffer = buffer;

  const band = ctx.createBiquadFilter();
  band.type = "bandpass";
  band.Q.value = 0.7;
  band.frequency.setValueAtTime(220, t0);
  band.frequency.exponentialRampToValueAtTime(1400, t0 + 0.9);
  band.frequency.exponentialRampToValueAtTime(260, t0 + dur);

  const low = ctx.createBiquadFilter();
  low.type = "lowpass";
  low.frequency.value = 2600;

  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.32, t0 + 0.45);
  gain.gain.setValueAtTime(0.32, t0 + 0.9);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);

  src.connect(band).connect(low).connect(gain).connect(ctx.destination);
  src.start(t0);
  src.stop(t0 + dur + 0.1);
  src.onended = () => ctx.close();
}
